import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-32">
      <div className="container">
        <div className="am-soft p-10 md:p-16 relative overflow-hidden">
          <div className="am-blob am-blob-lavender" style={{ left: "-160px", top: "-160px" }} />
          <div className="am-blob" style={{ right: "-160px", bottom: "-160px" }} />

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-2">
              <Link to="/" className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-full am-tile-pink">
                  <span className="h-2.5 w-2.5 rounded-full bg-white" />
                </span>
                <span className="font-display font-extrabold tracking-tight text-xl">AudioMine</span>
              </Link>
              <p className="mt-5 text-[15px] text-foreground/60 max-w-md leading-relaxed">
                A joyful music universe where discovery pays off. Listen deeper, play harder,
                and get rewarded with RPM — the token built for artists and the fans who love them.
              </p>
              <p className="mt-8 text-xs text-foreground/40">© {new Date().getFullYear()} PulsBeat Media · All rights reserved</p>
            </div>

            <div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-foreground/45 font-semibold">Explore</div>
              <ul className="mt-4 space-y-2.5 text-[15px]">
                <li><Link to="/for-artists" className="text-foreground/75 hover:text-primary transition-colors">For Artists</Link></li>
                <li><Link to="/for-fans" className="text-foreground/75 hover:text-primary transition-colors">For Fans</Link></li>
                <li><Link to="/how-it-works" className="text-foreground/75 hover:text-primary transition-colors">How It Works</Link></li>
                <li><Link to="/why-audiomine" className="text-foreground/75 hover:text-primary transition-colors">Why AudioMine</Link></li>
                <li><Link to="/contact" className="text-foreground/75 hover:text-primary transition-colors">Get Started</Link></li>
              </ul>
            </div>

            <div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-foreground/45 font-semibold">Say hi</div>
              <ul className="mt-4 space-y-3 text-[15px] text-foreground/75">
                <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-primary" /> keith@pulsbeat.ca</li>
                <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-primary" /> +1 (403) 816-9715</li>
                <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-primary mt-0.5" /> Waterloo · Calgary · Los Angeles</li>
              </ul>
              <div className="mt-5 flex items-center gap-2.5">
                {[Instagram, Twitter, Youtube].map((Icon, i) => (
                  <a key={i} href="#" aria-label="social"
                     className="h-9 w-9 flex items-center justify-center rounded-full bg-secondary text-foreground/70 hover:bg-primary hover:text-white transition-colors">
                    <Icon className="h-4 w-4" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-16" />
    </footer>
  );
}
